<template>
	<basic-block :value="value" :mode="mode" :state.sync="state">
		<template v-slot:main>
			<flip-card-view
				:mode="mode"
				:value="value"
				:side="visibleSide"
				:blockVariables="blockVariables"
				:editable="editable"
			/>

			<flip-card-toolbar
				v-if="isSelected"
				:visible-side="visibleSide"
				@reverse-event="onReverseButtonClicked"
			/>
		</template>
	</basic-block>
</template>

<script>
import BasicBlock from '../_components/containers/BasicBlock.vue';
import FlipCardView from './FlipCardView.vue';
import FlipCardToolbar from './FlipCardToolbar.vue';
import { FlipCardSide } from './flipCardSide';
import { sideIsRelatedToBlock } from './flipCardSideFunctions';
import { BlockSelectionState } from '../_models/blockSelectionState';

export default {
	name: 'BlockFlipCardEnhanced',
	inject: ['blocksSelector', 'blockGlobals'],
	props: ['value', 'mode', 'blockVariables'],
	components: {
		FlipCardToolbar,
		BasicBlock,
		FlipCardView
	},
	data() {
		return {
			visibleSide: FlipCardSide.front,
			state: BlockSelectionState.notSelected,
			editable: false
		};
	},
	created() {
		this.blocksSelector.$on('selection-changed', this.$onBlocksSelectionChanged);
	},
	computed: {
		isSelected() {
			return this.state !== BlockSelectionState.notSelected
		}
	},
	watch: {
		state() {
			if (this.state === BlockSelectionState.editContent) {
				this.editable = true;
				this.blocksSelector.$emit('childrenIdActive', this.visibleSide);
			} else {
				this.editable = false;
			}
		}
	},
	methods: {
		$flipCardSideOf(side) {
			return side === this.value.data.front ? FlipCardSide.front : FlipCardSide.back;
		},
		$makeSideVisibleIfSideIsRelatedToBlock(side, block) {
			if (sideIsRelatedToBlock(side, block)) {
				this.changeVisibleSide(this.$flipCardSideOf(side));
				return true;
			}
			return false;
		},
		$onBlocksSelectionChanged({ block, state }) {
			if (state !== BlockSelectionState.primarySelected) {
				return;
			}

			if (this.$makeSideVisibleIfSideIsRelatedToBlock(this.value.data.front, block)) return;
			this.$makeSideVisibleIfSideIsRelatedToBlock(this.value.data.back, block);
		},
		onReverseButtonClicked() {
			if (this.visibleSide === FlipCardSide.front) {
				this.changeVisibleSide(FlipCardSide.back);
			} else {
				this.changeVisibleSide(FlipCardSide.front);
			}
		},
		changeVisibleSide(side) {
			this.visibleSide = side;
			this.blocksSelector.$emit('childrenIdActive', side);
		}
	}
};
</script>